import React, {useEffect} from 'react';
import {BrowserRouter as Router, Switch, Route, Redirect} from "react-router-dom";
import {GoogleReCaptchaProvider} from "react-google-recaptcha-v3";
import {initializeApp} from "firebase/app";

import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsAndConditions from './pages/TermsAndConditions';
import Error404 from "./pages/Error404";
import ScrollToTop from "./helpers/ScrollToTop";
import firebaseConfig from "./fb-config.json";

const {
    initializeAppCheck,
    ReCaptchaEnterpriseProvider,
} = require('firebase/app-check')

const app = initializeApp(firebaseConfig);

const App = () => {
    useEffect(() => {
        initializeAppCheck(app, {
            provider: new ReCaptchaEnterpriseProvider(
                process.env.REACT_APP_RECAPTCHA_ID
            ),
            isTokenAutoRefreshEnabled: true, // Set to true to allow auto-refresh.
        })
    }, [])
    return (
        <GoogleReCaptchaProvider
            reCaptchaKey={process.env.REACT_APP_RECAPTCHA_ID}
            useRecaptchaNet
            useEnterprise
            scriptProps={{
                async: false, // optional, default to false,
                defer: false, // optional, default to false
                appendTo: 'head', // optional, default to "head", can be "head" or "body",
                nonce: undefined // optional, default undefined
            }}
        >
        <Router>
            <ScrollToTop>
                <Switch>
                    <Route exact path={`${process.env.PUBLIC_URL + '/'}`} component={Home}/>
                    <Route exact path={`${process.env.PUBLIC_URL + '/privacy-policy'}`} component={PrivacyPolicy}/>
                    <Route exact path={`${process.env.PUBLIC_URL + '/terms-and-conditions'}`} component={TermsAndConditions}/>
                    {/* Legacy routes from the previous multi-page site now live as sections on the home page */}
                    <Redirect from={`${process.env.PUBLIC_URL + '/about'}`} to={`${process.env.PUBLIC_URL + '/'}`}/>
                    <Redirect from={`${process.env.PUBLIC_URL + '/contact'}`} to={`${process.env.PUBLIC_URL + '/'}`}/>
                    <Redirect from={`${process.env.PUBLIC_URL + '/home-one'}`} to={`${process.env.PUBLIC_URL + '/'}`}/>
                    <Route exact component={Error404}/>
                </Switch>
            </ScrollToTop>
        </Router>
        </GoogleReCaptchaProvider>
    );
};

export default App;
